import { useState } from 'react'
import { LogoutIcon, UserIcon} from '@heroicons/react/outline'
import { LogoutModal } from './logout.modal.ui'
import {useAuth} from '../middleware/auth.middleware'



const Header = () => {

  const [open, setOpen] = useState(false);
  const _useAuth = useAuth()

  return (
    <div className="flex-1 px-4 flex justify-between">
      <div className="flex-1 flex">
        
      </div>
      <div className="ml-4 flex items-center md:ml-6">
        <div className="flex px-5">
          <UserIcon className="h-5 w-5 text-blue-600"/>
          <span className='text-blue-500 text-sm'>
            {_useAuth?.role?.toUpperCase()}
          </span>
        </div>
        <button
          type="button"
          className="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          onClick={() => {setOpen(true)}}
        >
          <span className="sr-only">View notifications</span>
          <div className='flex flex-row gap-2'>
            <p className=' text-gray-600'>Déconnexion</p>
            <LogoutIcon className="h-6 w-6 text-gray-600" aria-hidden="true" />
          </div>
        </button>

        <LogoutModal
            show={open}
            onClose={() => {setOpen(false)}}
            logout={() => {
              setOpen(false)
              _useAuth.logout()
            }}
          />

      </div>
    </div>
  )
}

export default Header